/**
 * In een groepsles (stap 23): welk deel de leerling leest en met wie hij in
 * een groepje zit, met het deel van elk ander kind (services/groepsles.py).
 */
import React from 'react';
import { Users } from 'lucide-react';

export function Groepje({ groepsles, style }) {
  if (!groepsles) return null;
  const { groepje, deel, aantal_delen: aantal, groepsleden = [] } = groepsles;
  return (
    <div style={{ background: 'var(--vlak)', borderRadius: 12, padding: 16, textAlign: 'left', ...style }} data-testid="mijn-groepje">
      <p style={{ fontSize: 17, margin: 0 }}>
        <Users size={18} style={{ verticalAlign: 'text-bottom', marginRight: 6 }} />
        Jij leest <strong>deel {deel}</strong> van de {aantal} delen. Je zit in <strong>groepje {groepje}</strong>.
      </p>
      {groepsleden.length > 0 && (
        <ul style={{ margin: '8px 0 0 28px', lineHeight: 1.6 }}>
          {groepsleden.map(g => <li key={g.naam}>{g.naam}: deel {g.deel}{g.deel === deel ? ' (net als jij)' : ''}</li>)}
        </ul>
      )}
    </div>
  );
}
